import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { FooterReport, Gap, GridInline, LabelTitle, Line, ProgressBar } from "../../../../components/Global";
import "react-loading-skeleton/dist/skeleton.css";
import { CONFIG_DEV } from "../../../../config/ConfigDev";
import accountManagement from "../../../../apis/accountManagement";
import LoaderModal from "../../../../components/modal/LoaderModal";
import PageTwo from "./PageTwo";
import LoadingPage from "./LoadingPage";

const PageOne = ({ idJadwalCbt, idKelas, idKelasParalel, kodeTahunAjaran }) => {
    const [fetching, setFetching] = useState(false);
    const [detailEvent, SetDetailEvent] = useState([]);
    const [dataMapel, SetdataMapel] = useState([]);
    const [listAverageKognitif, SetlistAverageKognitif] = useState([]);
    const [averageMatematika, setaverageMatematika] = useState(false);
    const [averageIndo, setaverageIndo] = useState(false);
    const [averageIngg, setaverageIngg] = useState(false);
    const [averageIpa, setaverageIpa] = useState(false);
    const [averageIps, setaverageIps] = useState(false);
    const [openPage, setOpenPage] = useState(false);
    const colors = ["#3f51b5", "#f44336", "#4caf50", "#ff9800", "#9c27b0", "#2196f3", "#009688", "#ffeb3b", "#795548", "#607d8b"];
    const [riasec, setRiasec] = useState(false);

    const today = new Date();
    const suflix = today.getHours() >= 12 ? " PM" : " AM";
    const dateTime = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + ", " + today.getHours() + "." + today.getMinutes() + suflix;

    useEffect(() => {
        const getDatas = async () => {
            setFetching(true);

            const params = {
                idJadwalCbt: idJadwalCbt,
                idKelas: idKelas,
                idKelasParalel: idKelasParalel,
                kodeTahunAjaran: kodeTahunAjaran,
            };

            const response = await accountManagement.get(CONFIG_DEV.REPORT_PEMETAAN3_PAGE_ONE, { params }).catch(function (error) {
                console.error("Error HW_REPORT_BY_KP", error);
            });

            if (response) {
                if (response.data.data) {
                    const responseAPI = response.data.data;
                    console.log("====================================");
                    console.log("Response Page One ", responseAPI);
                    console.log("====================================");

                    SetDetailEvent(responseAPI.detailEvent);
                    SetdataMapel(responseAPI.dataMapel);
                    SetlistAverageKognitif(responseAPI.listAverageKognitif);
                    setaverageMatematika(responseAPI.listAverageKognitif[0]);
                    setaverageIndo(responseAPI.listAverageKognitif[2]);
                    setaverageIngg(responseAPI.listAverageKognitif[3]);
                    setaverageIpa(responseAPI.listAverageKognitif[1]);
                    setaverageIps(responseAPI.listAverageKognitif[4]);
                }
                setFetching(false);
                setOpenPage(true);
            }
        };
        getDatas();
    }, []);

    require("../Pemetaan.css");
    return (
        <>
            <LoaderModal isFetching={fetching} />
            <div className="report-page">
                <div className="header-first-page">
                    <div className="text-header">
                        <div className="title-header">SCHOOL ASSESSMENT REPORT</div>
                        <div className="sub-title-header">
                            <b>Asesmen Diagnostik</b>
                        </div>
                    </div>
                    <div className="img-header">
                        <img src="/assets/image/pemetaan.png" width={"20%"} alt="" />
                    </div>
                </div>
                <Gap height={20} />
                <div style={{ width: "95%", paddingLeft: "5%" }}>
                    <Line color={"#1D3557"} />
                </div>
                <Gap height={20} />
                <div className="section-one">
                    <div className="biodata-school">
                        {/* Nama Sekolah */}
                        <GridInline width={"50%"} borderRight={"1px solid #E9ECEF"}>
                            <GridInline width={"7%"} marginRight={5}>
                                <img src="/assets/image/school.png" width={"100%"} style={{ marginBottom: -15 }} alt="" />
                            </GridInline>
                            <GridInline width={"75%"}>
                                <LabelTitle label={"Nama Sekolah"} size={20} bolder={500} color={"#495057"} />
                            </GridInline>
                            <div style={{ marginLeft: 35 }}>
                                <LabelTitle label={detailEvent.namaSekolah} size={19} bolder={500} color={"#6C757D"} />
                            </div>
                            <Gap height={20} />
                            <GridInline width={"7%"} marginRight={5}>
                                <img src="/assets/image/umur.png" width={"100%"} style={{ marginBottom: -15 }} alt="" />
                            </GridInline>
                            <GridInline width={"75%"}>
                                <LabelTitle label={"Nama Kelas"} size={20} bolder={500} color={"#495057"} />
                            </GridInline>
                            <div style={{ marginLeft: 35 }}>
                                <LabelTitle label={detailEvent.namaKelas} size={19} bolder={500} color={"#6C757D"} />
                            </div>
                        </GridInline>
                        <GridInline width={"50%"} paddingLeft={20}>
                            {/* Jumlah Peserta */}
                            <GridInline width={"7%"} marginRight={5}>
                                <img src="/assets/image/jumlah-peserta.png" width={"100%"} style={{ marginBottom: -15 }} alt="" />
                            </GridInline>
                            <GridInline width={"75%"}>
                                <LabelTitle label={"Jumlah Siswa"} size={20} bolder={500} color={"#495057"} />
                            </GridInline>
                            <div style={{ marginLeft: 35 }}>
                                <LabelTitle label={detailEvent.jumlahSiswa + " Siswa"} size={19} bolder={500} color={"#6C757D"} />
                            </div>
                            <Gap height={20} />
                            {/* Tanggal Event */}
                            <GridInline width={"7%"} marginRight={5}>
                                <img src="/assets/image/tgl.png" width={"100%"} style={{ marginBottom: -15 }} alt="" />
                            </GridInline>
                            <GridInline width={"75%"}>
                                <LabelTitle label={"Tanggal Event"} size={20} bolder={500} color={"#495057"} />
                            </GridInline>
                            <div style={{ marginLeft: 35 }}>
                                <LabelTitle label={detailEvent.tglEvent} size={19} bolder={500} color={"#6C757D"} />
                            </div>
                        </GridInline>
                    </div>
                    <Gap height={20} />
                    <div style={{ width: "95%", paddingLeft: "5%" }}>
                        <Line color={"#E9ECEF"} />
                    </div>
                    <Gap height={20} />
                    <div className="result">
                        <div className="result-pageone">
                            <LabelTitle label={"Summary Asesmen Diagnostik Kognitif"} size={20} bolder={800} color={"#fff"} />
                        </div>
                        <Gap height={20} />
                        {/* <div className="head-table-result">
                            <GridInline width={"100%"} padding={15} marginLeft={15}>
                                <GridInline width={"48%"} marginLeft={15} paddingTop={10}>
                                    <LabelTitle label={"Mata Pelajaran"} size={20} bolder={800} color={"#000"} />
                                </GridInline>
                                <GridInline width={"25%"} textAlign={"center"}>
                                    <LabelTitle label={"Recomendation"} size={20} bolder={800} color={"#000"} />
                                </GridInline>
                                <GridInline width={"25%"} textAlign={"center"}>
                                    <LabelTitle label={"Placement"} size={20} bolder={800} color={"#000"} />
                                </GridInline>
                            </GridInline>
                        </div> */}
                        <div className="table-result" style={{ border: 0 }}>
                            {dataMapel.map((mapel, i) => {
                                return (
                                    <div key={i} style={{ borderBottom: "1px #000 solid", paddingTop: 15 }}>
                                        <GridInline width={"100%"} padding={15} marginLeft={15}>
                                            <GridInline width={"28%"} paddingTop={10}>
                                                {mapel.namaMapel}
                                            </GridInline>
                                            <GridInline width={"18%"} textAlign={"center"}>
                                                <GridInline width={"100%"} padding={15}>
                                                    <GridInline width={"15%"} textAlign={"center"}>
                                                        <img src="/assets/image/tinggi.png" width={"100%"} alt="" style={{ verticalAlign: "inherit" }} />
                                                    </GridInline>
                                                    <GridInline width={"80%"} textAlign={"center"}>
                                                        <LabelTitle label={"Tinggi"} size={16} bolder={800} color={"#000"} />
                                                        {mapel.prosenTinggi}% - {mapel.katTinggi} Siswa
                                                    </GridInline>
                                                </GridInline>
                                            </GridInline>
                                            <GridInline width={"18%"} textAlign={"center"}>
                                                <GridInline width={"100%"} padding={15}>
                                                    <GridInline width={"15%"} textAlign={"center"}>
                                                        <img src="/assets/image/sedang.png" width={"100%"} alt="" style={{ verticalAlign: "inherit" }} />
                                                    </GridInline>
                                                    <GridInline width={"80%"} textAlign={"center"}>
                                                        <LabelTitle label={"Sedang"} size={16} bolder={800} color={"#000"} />
                                                        {mapel.prosenSedang}% - {mapel.katSedang} Siswa
                                                    </GridInline>
                                                </GridInline>
                                            </GridInline>
                                            <GridInline width={"18%"} textAlign={"center"}>
                                                <GridInline width={"100%"} padding={15}>
                                                    <GridInline width={"15%"} textAlign={"center"}>
                                                        <img src="/assets/image/rendah.png" width={"100%"} alt="" style={{ verticalAlign: "inherit" }} />
                                                    </GridInline>
                                                    <GridInline width={"80%"} textAlign={"center"}>
                                                        <LabelTitle label={"Rendah"} size={16} bolder={800} color={"#000"} />
                                                        {mapel.prosenRendah}% - {mapel.katRendah} Siswa
                                                    </GridInline>
                                                </GridInline>
                                            </GridInline>
                                            <GridInline width={"18%"} textAlign={"center"}>
                                                <GridInline width={"100%"} padding={15}>
                                                    <GridInline width={"15%"} textAlign={"center"}>
                                                        <img src="/assets/image/sangat-rendah.png" width={"100%"} alt="" style={{ verticalAlign: "inherit" }} />
                                                    </GridInline>
                                                    <GridInline width={"80%"} textAlign={"center"}>
                                                        <LabelTitle label={"Sangat Rendah"} size={16} bolder={800} color={"#000"} />
                                                        {mapel.prosenSangatRendah}% - {mapel.katSangatRendah} Siswa
                                                    </GridInline>
                                                </GridInline>
                                            </GridInline>
                                        </GridInline>
                                    </div>
                                );
                            })}
                        </div>
                        <Gap height={50} />
                        <LabelTitle label={"RATA-RATA ASESMEN DIAGNOSTIK KOGNITIF"} size={16} bolder={700} color={"#000"} />
                        <Gap height={10} />
                        <div className="table-result" style={{ border: 0 }}>
                            {listAverageKognitif.map((item, i) => {
                                return (
                                    <GridInline width={"100%"} paddingBottom={10}>
                                        <GridInline width={"95%"}>
                                            <LabelTitle label={item.mataPelajaran} size={14} bolder={600} color={"grey"} />
                                            <ProgressBar ratio={100} progressColor={colors[i]} progressValue={item.rataRata} heightBar={15} />
                                        </GridInline>
                                        <GridInline width={"5%"} textAlign={"left"} verticalAlign={"bottom"} paddingLeft={7} paddingBottom={5}>
                                            <LabelTitle label={item.rataRata} size={14} bolder={600} color={"#000"} />
                                        </GridInline>
                                    </GridInline>
                                );
                            })}
                        </div>
                    </div>
                </div>
                {/* <Gap height={40} /> */}
                {/* <div className="reportFooter">
                    <FooterReport color={"#1D3557"} date={dateTime} />
                </div> */}
            </div>

            {openPage ? <PageTwo idJadwalCbt={idJadwalCbt} idKelas={idKelas} idKelasParalel={idKelasParalel} kodeTahunAjaran={kodeTahunAjaran} schoolName={detailEvent.namaSekolah} isRiasec={riasec} /> : <LoadingPage />}
        </>
    );
};

export default PageOne;
